const development = {
  // Dev env realtime database
  apiKey: "AIzaSyA65ToSfgGGdAZyD_9XvCp1QbMHu7bjEJc",
  authDomain: "kidsmatin-dev.firebaseapp.com",
  databaseURL: "https://kidsmatin-dev.firebaseio.com",
  projectId: "kidsmatin-dev",
  storageBucket: "kidsmatin-dev.appspot.com",
  messagingSenderId: "778932804460"
};

const staging = {
  // Staging env realtime database
  apiKey: "AIzaSyBRyGtLw9wrb2z57wdjfBRaeQdxhK97rSg",
  authDomain: "kidsmatin-staging.firebaseapp.com",
  databaseURL: "https://kidsmatin-staging.firebaseio.com",
  projectId: "kidsmatin-staging",
  storageBucket: "kidsmatin-staging.appspot.com",
  messagingSenderId: "1084159527340"
};

const production = {
  // Production env realtime database
  apiKey: "AIzaSyDKkKbwsnfAzw38SSLYx39jFEd-ZKLMzaM",
  authDomain: "kidsmatin-prod.firebaseapp.com",
  databaseURL: "https://kidsmatin-prod.firebaseio.com",
  projectId: "kidsmatin-prod",
  storageBucket: "kidsmatin-prod.appspot.com",
  messagingSenderId: "395896818384"
};

let config = development;
if( process.env.REACT_APP_ENV !== undefined && ['development', 'staging', 'production'].includes(process.env.REACT_APP_ENV) ) {
  if( process.env.REACT_APP_ENV === 'production' ) config = production;
  else if( process.env.REACT_APP_ENV === 'staging' ) config = staging;
}

export const firebaseConfig = config;


// WEBPACK FOOTER //
// ./src/conf/firebase.js